import type { TCond } from '$lib/common/cond.type';
import type { TCometdEventData, TEvent } from '$lib/services/cometd/cometd.types';
import { identity } from 'lodash-es';
import type { TCreateEventConverterProps, TEventConverterPayloads } from './eventConverter.types';

export const createEventConverter = ({
    kind,
    eventKey,
    isEvent = (event: TEvent) => eventKey in event.data,
    convert = identity
}: TCreateEventConverterProps): TCond<TEvent, TEventConverterPayloads> => {
    const eventConverter = (event: TEvent) => {
        // if more than one key is needed use custom logic, do not want to over engineer

        const data: TCometdEventData = event.data;
        return {
            kind,
            ...(typeof data[eventKey] === 'object' && data[eventKey] !== null
                ? data[eventKey]
                : {}),
            ...convert(data)
        } as TEventConverterPayloads;
    };
    return [isEvent, eventConverter];
};
